export var SearchBoxStyles = function SearchBoxStyles(props) {
  var theme = props.theme,
      hasFocus = props.hasFocus,
      hasInput = props.hasInput,
      underlined = props.underlined,
      disabled = props.disabled;
  var effects = theme.effects,
      palette = theme.palette,
      semanticColors = theme.semanticColors;
  var inputIcon = palette.themeDarkAlt;
  var inputIconAlt = palette.neutralSecondary;
  var inputIconAltHovered = palette.neutralPrimary;
  var inputIconDisabled = palette.neutralTertiary;
  var inputBackgroundHovered = palette.neutralLighter;
  return {
    root: [{
      borderRadius: effects.roundedCorner2,
      borderColor: semanticColors.inputBorder,
      paddingTop: 0,
      paddingBottom: 0,
      selectors: {
        ':hover ': {
          borderColor: semanticColors.inputBorderHovered
        },
        ':active': {
          borderColor: semanticColors.inputFocusBorderAlt
        }
      }
    }, !hasFocus && hasInput && {
      selectors: {
        '.ms-SearchBox-iconContainer': {
          width: 4
        },
        '.ms-SearchBox-icon': {
          opacity: 0
        }
      }
    }, hasFocus && {
      borderColor: semanticColors.inputFocusBorderAlt
    }, underlined && {
      borderRadius: 0
    }],
    iconContainer: {
      color: disabled ? inputIconDisabled : inputIcon
    },
    field: {
      paddingLeft: 6
    },
    clearButton: {
      padding: 0,
      selectors: {
        '&:hover .ms-Button': {
          backgroundColor: inputBackgroundHovered
        },
        '&:hover .ms-Button-icon': {
          color: inputIconAltHovered
        },
        '.ms-Button-icon': {
          color: inputIconAlt
        }
      }
    }
  };
};